
// Credit award configuration
export const CreditAward = {
  newUser: 40,
  daily: 0,
  discord: 20
};

export interface PermanentCreditHistoryMessage {
  name: string;
  date: string;
  amount: number;
  // no expire date, daily credit history will be hardcoded to present day
}

export interface CreditInfo {
  has_received_discord: boolean;
  has_received_daily: boolean;
  credit_history: PermanentCreditHistoryMessage[];
}

